<template>
	<div>
		<breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'周计划提报情况'}]" />
		<div class="h-content">

			<div class="h-piece">
				<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
					<div class="h-formBox w-formBox">
						<div class="tow-formBox">
							<el-form-item label="用户名称">
								<el-input v-model="q.cuname" placeholder="用户名称" :clearable="false"></el-input>
							</el-form-item>
							<el-form-item label="　周计划时间">
								<el-date-picker :clearable="false" type="date" placeholder="选择时间" value-format="yyyy-MM-dd"
								 v-model="q.planTimeStart"></el-date-picker>
							</el-form-item>
						</div>
						<el-form-item>
							<el-button class="h-btn h-formBtn" @click="query">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>

			<!--展示表格-->
			<div class="h-table h-mrt30">
			    <el-table
			            ref="ddtable"
			            :data="tableData"
						:border="true"
			            stripe
			            style="width: 100%"
			    >
					<el-table-column
						type="index"
						label="#"
						width="40">
					</el-table-column>
					<el-table-column
							prop="cucode"
							:show-overflow-tooltip="true"
							label="提报人工号"
					>
					</el-table-column>
					<el-table-column
						prop="cuname"
						:show-overflow-tooltip="true"
						label="提报人名称"
						>
					</el-table-column>
					<el-table-column
						prop="cdate"
						:show-overflow-tooltip="true"
						label="提报日期"
						>
						<template slot-scope="scope">
							<div v-if="scope.row.cdate == null">/</div>
							<div v-if="scope.row.cdate != null">{{scope.row.cdate}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="sumplan"
						:show-overflow-tooltip="true"
						label="计划总数"
						>
						<template slot-scope="scope">
							<div v-if="scope.row.sumplan == null">/</div>
							<div v-if="scope.row.sumplan != null">{{scope.row.sumplan}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="planStatus"
						:show-overflow-tooltip="true"
						label="计划状态"
						>
						<template slot-scope="scope">
							<div v-if="scope.row.planStatus == 0 || scope.row.planStatus == null">未提报
							<el-button class="h-tableLink h-btn" v-if="scope.row.planStatus == 0 || scope.row.planStatus == null" @click="tixing(scope.row)" style="position:relative;z-index:1">提醒</el-button></div>
						    <div v-if="scope.row.planStatus == 1">审批中</div>
							<div v-if="scope.row.planStatus == 2">通过</div>
							<div v-if="scope.row.planStatus == 3">驳回</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="fenyes">
				<pagination :page="q" @query="query" />
			</div>
		</div>
	</div>
</template>

<script>
	import ss from '../../api/SystemService'
	export default {
		data() {
			return {
				q:{
					cuname:null,
					planTimeStart:null,
					planTimeEnd:null,
					planStatus:null,
					pageSize: 10,
					pageNo: 1,
					total: 0,
				},
				tableData:[],
				options2:[{code:0,name:'未提报'},{code:1,name:'审批中'},{code:2,name:'通过'},{code:3,name:'驳回'}],
			}
		},
		created(){
			this.query();
		},
		methods:{
			tixing(v){
				ss.UserCare.tixing(v.cucode).then(rd => {
					this.$msg.msgs(rd.msg);
					this.query();
				})
			},
			query(){
				ss.UserCare.planStatusPage(this.q).then(rd => {
					this.q.total = rd.total;
					this.tableData = rd.records;
				})
			},
			reset(){
				this.q.planStatus = null;
				this.q.cuname = null;
				this.q.planTimeStart = null;
				this.q.planTimeEnd = null;
			},
			chakan(v){
				var taskstatus;
				if(v.planStatus == 1){
					taskstatus = 0;
				}else{
					taskstatus=1;
				}
				this.$router.push({
					path: '/weekplan_detail',
					query: {ywid: v.careWeek,taskstatus:taskstatus,instid:v.instid}
				});
				/*this.$router.push({
					path: '/shijipaodong',
					query: {cucode: v.cucode,cdate:v.cdate}
				});*/
			},
			shenpi(v){
				this.$router.push({
					path: '/weekplan_detail',
					query: {ywid: v.id}
				});
			}
		}
	}
</script>

<style scoped>
	.fenyes {
		margin-top: 20px;
	}
</style>
